document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-tarli-product]');
  if (!root) return;

  const track = root.querySelector('[data-gallery-track]');
  const slides = [...root.querySelectorAll('[data-gallery-slide]')];
  const count = root.querySelector('.gallery-count');
  const thumbnails = [...root.querySelectorAll('[data-tarli-index]')];
  let activeImage = 0;
  const showImage = index => {
    if (!slides.length) return;
    activeImage = (index + slides.length) % slides.length;
    const button = thumbnails[activeImage];
    const slide = slides[activeImage];
    if (track && slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    thumbnails.forEach(item => item.classList.remove('active'));
    button?.classList.add('active');
    const thumbnailRail = button?.parentElement;
    if (thumbnailRail && button) {
      const top = button.offsetTop;
      const bottom = top + button.offsetHeight;
      if (top < thumbnailRail.scrollTop) thumbnailRail.scrollTo({ top, behavior: 'smooth' });
      else if (bottom > thumbnailRail.scrollTop + thumbnailRail.clientHeight) thumbnailRail.scrollTo({ top: bottom - thumbnailRail.clientHeight, behavior: 'smooth' });
    }
    if (count) count.textContent = `${activeImage + 1} / ${slides.length}`;
  };
  thumbnails.forEach((button, index) => button.addEventListener('click', () => showImage(index)));
  root.querySelector('.gallery-prev')?.addEventListener('click', () => showImage(activeImage - 1));
  root.querySelector('.gallery-next')?.addEventListener('click', () => showImage(activeImage + 1));
  root.querySelector('.gallery-zoom')?.addEventListener('click', () => slides[activeImage]?.querySelector('img')?.requestFullscreen?.());
  const mainShot = root.querySelector('.main-shot');
  let touchStartX = 0;
  let wheelLocked = false;
  mainShot?.addEventListener('touchstart', event => { touchStartX = event.changedTouches[0].clientX; }, { passive: true });
  mainShot?.addEventListener('touchend', event => {
    const distance = event.changedTouches[0].clientX - touchStartX;
    if (Math.abs(distance) > 45) showImage(activeImage + (distance < 0 ? 1 : -1));
  }, { passive: true });
  mainShot?.addEventListener('wheel', event => {
    if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
    const movement = event.deltaX;
    if (Math.abs(movement) < 18) return;
    event.preventDefault();
    if (wheelLocked) return;
    wheelLocked = true;
    showImage(activeImage + (movement > 0 ? 1 : -1));
    window.setTimeout(() => { wheelLocked = false; }, 320);
  }, { passive: false });
  let scrollTimer;
  track?.addEventListener('scroll', () => {
    window.clearTimeout(scrollTimer);
    scrollTimer = window.setTimeout(() => {
      const next = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      if (next !== activeImage && slides[next]) {
        activeImage = next;
        thumbnails.forEach((item, index) => item.classList.toggle('active', index === activeImage));
        if (count) count.textContent = `${activeImage + 1} / ${slides.length}`;
      }
    }, 70);
  }, { passive: true });

  const variantsNode = root.querySelector('[data-product-variants]');
  if (variantsNode) {
    const variants = JSON.parse(variantsNode.textContent);
    const groups = [...root.querySelectorAll('[data-option-index]')];
    const variantInput = root.querySelector('[data-variant-id]');
    const addButton = root.querySelector('.add-main');
    const selections = groups.map(group => group.querySelector('.selected')?.dataset.optionValue || group.querySelector('[data-option-select]')?.value || '');

    const showVariantMedia = variant => {
      if (!variant) return;
      const mediaId = variant.featured_media?.id || variant.featured_image?.id;
      let imageIndex = mediaId ? slides.findIndex(slide => slide.dataset.mediaId === String(mediaId)) : -1;
      if (imageIndex < 0 && variant.featured_image?.src) {
        const target = variant.featured_image.src.split('?')[0];
        imageIndex = slides.findIndex(slide => {
          const image = slide.querySelector('img');
          return (image?.currentSrc || image?.src || '').split('?')[0] === target;
        });
      }
      if (imageIndex >= 0 && imageIndex !== activeImage) showImage(imageIndex);
    };

    const ukLabel = raw => {
      const value = raw.trim();
      const explicit = value.match(/UK\s*([0-9]+(?:\.5)?)/i);
      if (explicit) return `UK ${explicit[1]}`;
      const dressNumber = value.match(/\(([0-9]{1,2})\)/);
      if (dressNumber) return `UK ${dressNumber[1]}`;
      return value.replace(/\s*\/\s*EU.*$/i, '');
    };
    const swatchColour = raw => {
      const name = raw.toLowerCase().trim();
      const colours = {
        'black':'#111111','white':'#f7f7f4','cream':'#eee5d3','beige':'#d8c5a5','apricot':'#efc5a5','khaki':'#a39169','camel':'#b98959','brown':'#76503c','dark brown':'#51382f',
        'grey':'#999999','gray':'#999999','silver':'#c7c8ca','blue':'#416b9b','dark blue':'#243a5a','navy blue':'#17253e','sky blue':'#9dc9df','light blue':'#b7d4e5','baby blue':'#b8d8ea','sapphire blue':'#17569b',
        'green':'#47735a','yellow':'#e6c84f','lemon':'#eee57d','orange':'#d8793e','red':'#b3262e','dark red':'#741f27','wine red':'#762d40','wine':'#762d40','burgundy':'#6e2639','pink':'#dd91a8','baby pink':'#e9b6c2','rose red':'#c83d68','blush':'#dda8a3','purple':'#74517e'
      };
      if (name.includes('leopard')) return 'repeating-linear-gradient(135deg,#c99a60 0 7px,#5b3b25 7px 11px,#d8b17b 11px 18px)';
      return colours[name] || name.replace(/\s+/g, '');
    };

    groups.forEach((group, optionIndex) => {
      group.querySelectorAll('[data-option-value]').forEach(button => {
        if (button.dataset.optionKind === 'size') button.querySelector('span').textContent = ukLabel(button.dataset.optionValue);
        if (button.dataset.optionKind === 'colour') button.style.setProperty('--swatch-colour', swatchColour(button.dataset.optionValue));
        button.addEventListener('click', () => {
          selections[optionIndex] = button.dataset.optionValue;
          group.querySelectorAll('[data-option-value]').forEach(item => item.classList.remove('selected'));
          button.classList.add('selected');
          const selectedLabel = group.querySelector('[data-selected-option]');
          if (selectedLabel) selectedLabel.textContent = button.dataset.optionKind === 'size' ? ukLabel(button.dataset.optionValue) : button.dataset.optionValue;
          updateVariantState();
        });
      });
      const initial = group.querySelector('.selected');
      const selectedLabel = group.querySelector('[data-selected-option]');
      if (initial && selectedLabel) selectedLabel.textContent = initial.dataset.optionKind === 'size' ? ukLabel(initial.dataset.optionValue) : initial.dataset.optionValue;
      const select = group.querySelector('[data-option-select]');
      if (select) {
        [...select.options].forEach(option => { if (option.value) option.textContent = ukLabel(option.value); });
        select.addEventListener('change', () => {
          selections[optionIndex] = select.value;
          if (selectedLabel) selectedLabel.textContent = select.value ? ukLabel(select.value) : 'Select size';
          updateVariantState();
        });
      }
    });

    function updateVariantState() {
      groups.forEach((group, optionIndex) => {
        group.querySelectorAll('[data-option-value]').forEach(button => {
          const possible = variants.some(variant => variant.available && variant.options.every((value, index) => index === optionIndex ? value === button.dataset.optionValue : !selections[index] || value === selections[index]));
          button.classList.toggle('unavailable', !possible);
        });
        const select = group.querySelector('[data-option-select]');
        if (select) [...select.options].forEach(option => {
          if (!option.value) return;
          option.disabled = !variants.some(variant => variant.available && variant.options.every((value, index) => index === optionIndex ? value === option.value : !selections[index] || value === selections[index]));
        });
      });
      const selected = variants.find(variant => variant.options.every((value, index) => value === selections[index]));
      if (selected && variantInput) variantInput.value = selected.id;
      const mediaVariant = selected || variants.find(variant => variant.options.every((value, index) => !selections[index] || value === selections[index]));
      showVariantMedia(mediaVariant);
      if (addButton) {
        const incomplete = selections.some(value => !value);
        addButton.disabled = incomplete || !selected?.available;
        if (incomplete) addButton.textContent = 'Select a size';
        else if (!selected?.available) addButton.textContent = 'Unavailable';
        else addButton.textContent = addButton.dataset.addLabel || 'Add to bag';
      }
    }
    updateVariantState();
  }

  const description = root.querySelector('.product-copy');
  if (description) {
    const extracted = [];
    description.querySelectorAll('li').forEach(item => {
      const lead = item.querySelector('strong, b');
      if (!lead) return;
      const key = lead.textContent.replace(/:\s*$/, '').trim();
      const value = item.textContent.replace(lead.textContent, '').replace(/^:\s*/, '').trim();
      if (key && value && key.length < 48 && !extracted.some(spec => spec.key.toLowerCase() === key.toLowerCase())) extracted.push({ key, value });
    });
    root.querySelectorAll('[data-product-specs]').forEach(list => extracted.slice(0, 8).forEach(spec => {
      const row = document.createElement('div');
      const term = document.createElement('dt');
      const detail = document.createElement('dd');
      term.textContent = spec.key;
      detail.textContent = spec.value;
      row.append(term, detail);
      list.append(row);
    }));
  }

  root.querySelectorAll('.size-guide').forEach(button => button.addEventListener('click', () => {
    const fit = root.querySelector('#size-fit');
    if (fit) { fit.open = true; fit.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  }));

  const mainForm = root.querySelector('.tarli-product-form');
  const mainAdd = root.querySelector('.add-main');
  const sticky = root.querySelector('[data-sticky-buy]');
  const stickySubmit = root.querySelector('[data-sticky-submit]');
  stickySubmit?.addEventListener('click', () => mainForm?.requestSubmit());

  mainForm?.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (!mainForm.checkValidity() || !mainAdd || mainAdd.disabled) return;

    const originalLabel = mainAdd.textContent;
    mainAdd.disabled = true;
    mainAdd.textContent = 'Adding…';

    try {
      const formData = new FormData(mainForm);
      formData.append('sections', 'cart-drawer-section');
      formData.append('sections_url', window.location.pathname);

      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      });
      const result = await response.json();

      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || 'Unable to add this item.');
      }

      const drawerHTML = result.sections?.['cart-drawer-section'];
      const currentDrawerSection = document.querySelector('#shopify-section-cart-drawer-section');
      if (drawerHTML && currentDrawerSection) {
        const parsedDocument = new DOMParser().parseFromString(drawerHTML, 'text/html');
        const nextDrawerSection = parsedDocument.querySelector('#shopify-section-cart-drawer-section');
        if (nextDrawerSection) currentDrawerSection.replaceWith(nextDrawerSection);
      }

      const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`);
      const cart = await cartResponse.json();
      document.querySelectorAll('.bag-count').forEach((count) => {
        count.textContent = String(cart.item_count);
      });

      await customElements.whenDefined('theme-drawer');
      const drawer = document.querySelector('#cart-drawer');
      if (typeof drawer?.open === 'function') drawer.open();
    } catch (error) {
      mainAdd.textContent = error instanceof Error ? error.message : 'Unable to add this item.';
      window.setTimeout(() => {
        mainAdd.textContent = originalLabel;
      }, 3000);
    } finally {
      mainAdd.disabled = false;
      if (mainAdd.textContent === 'Adding…') mainAdd.textContent = originalLabel;
    }
  });

  if (mainAdd && sticky) {
    new IntersectionObserver(([entry]) => sticky.classList.toggle('visible', !entry.isIntersecting), { threshold: 0 }).observe(mainAdd);
  }

  const related = root.querySelector('[data-related-products]');
  if (related) {
    let activeMode = 'recommended';
    const shownByMode = { recommended: 8, category: 8 };
    const tabs = [...related.querySelectorAll('[data-related-tab]')];
    const grids = [...related.querySelectorAll('[data-related-grid]')];
    const more = related.querySelector('[data-related-more]');

    const renderRelated = () => {
      grids.forEach(grid => {
        const active = grid.dataset.relatedGrid === activeMode;
        grid.classList.toggle('active', active);
        const cards = [...grid.querySelectorAll('.related-product')];
        cards.forEach((card, index) => card.classList.toggle('visible', active && index < shownByMode[activeMode]));
        if (active && more) more.parentElement.hidden = cards.length <= shownByMode[activeMode];
      });
      tabs.forEach(tab => tab.classList.toggle('active', tab.dataset.relatedTab === activeMode));
    };
    tabs.forEach(tab => tab.addEventListener('click', () => { activeMode = tab.dataset.relatedTab; renderRelated(); }));
    more?.addEventListener('click', () => { shownByMode[activeMode] += 8; renderRelated(); });
    renderRelated();
  }
});
